import { render, staticRenderFns } from "./LandingHeaderWithImage.vue?vue&type=template&id=2a06c167&scoped=true&name=landing-header-with-image&"
import script from "./LandingHeaderWithImage.vue?vue&type=script&lang=js&"
export * from "./LandingHeaderWithImage.vue?vue&type=script&lang=js&"
import style0 from "./LandingHeaderWithImage.vue?vue&type=style&index=0&id=2a06c167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06c167",
  null
  
)

export default component.exports